export const UX_COPY_HI = {
  "quickNavAria": "पृष्ठ अनुभागों के त्वरित लिंक",
  "skipToSections": "अनुभाग मेनू पर जाएं",
  "jumpToStudioHint": "शॉर्टकट: Alt + S"
};

export const TRIAL_FLOW_COPY_HI = {
  "flowLabel": "यह कैसे काम करता है",
  "flowSteps": [
    "त्वरित परीक्षण के लिए एक छवि चुनें।",
    "अपने चुने हुए बाज़ार के साथ Metadata Studio में जारी रखें।",
    "निर्यात से पहले परिणाम की समीक्षा करें और संपादित करें।"
  ]
};

export const LANDING_SALES_COPY_HI = {};


export default LANDING_SALES_COPY_HI;
